"use client";

import { c as _c } from "react/compiler-runtime";
import { waitlistAction } from "@/lib/actions/email";
import { useActionState } from "react";
import { Alert, AlertDescription, AlertTitle } from "../ui/alert";
import { Button } from "../ui/button";
import { Dialog, DialogContent, DialogDescription, DialogHeader, DialogTitle, DialogTrigger } from "../ui/dialog";
import { Icon } from "../ui/icon";
import { Input } from "../ui/input";
export const WaitlistSignup = () => {
  const $ = _c(12);
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = {
      error: ""
    };
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  const [state, action, pending] = useActionState(waitlistAction, t0);
  let t1;
  if ($[1] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = <DialogTrigger asChild={true}><Button size="lg" className="text-base md:text-lg md:px-12 md:py-8 shadow-lg shadow-sky-300/40 hover:shadow-sky-400/50 transition-shadow duration-500">Join Waitlist</Button></DialogTrigger>;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  let t2;
  if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = <DialogTitle>Join Waitlist</DialogTitle>;
    $[2] = t2;
  } else {
    t2 = $[2];
  }
  const t3 = state.success ? "Thank you!" : "Enter your email to be notified when FinalSpaces is available.";
  let t4;
  if ($[3] !== t3) {
    t4 = <DialogHeader>{t2}<DialogDescription>{t3}</DialogDescription></DialogHeader>;
    $[3] = t3;
    $[4] = t4;
  } else {
    t4 = $[4];
  }
  let t5;
  if ($[5] !== pending || $[6] !== state.email || $[7] !== state.success) {
    t5 = <form action={action}>{state.success ? <Alert><Icon icon="mdi:email-check" className="mr-2 size-6" /><AlertTitle>Please check your email for a confirmation message.</AlertTitle><AlertDescription><p>Once confirmed, you will be notified when FinalSpaces is available.</p></AlertDescription></Alert> : <div className="flex items-center gap-1"><Input type="email" name="email" defaultValue={state.email} placeholder="example@email.com" required={true} /><Button type="submit" variant="outline" disabled={pending}>Submit</Button></div>}</form>;
    $[5] = pending;
    $[6] = state.email;
    $[7] = state.success;
    $[8] = t5;
  } else {
    t5 = $[8];
  }
  let t6;
  if ($[9] !== t4 || $[10] !== t5) {
    t6 = <Dialog>{t1}<DialogContent className="sm:max-w-md">{t4}{t5}</DialogContent></Dialog>;
    $[9] = t4;
    $[10] = t5;
    $[11] = t6;
  } else {
    t6 = $[11];
  }
  return t6;
};